import {
  Search,
  Palette,
  Code,
  TestTube,
  Rocket,
  Eye,
  Award,
  Users,
  TrendingUp
} from 'lucide-vue-next';

export const processSteps = [
  {
    id: 1,
    number: '01',
    title: 'Discovery & Strategy',
    description: 'We begin by deeply understanding your business goals, user needs, and technical requirements to create a solid foundation for success.',
    activities: [
      'Stakeholder interviews and requirements gathering',
      'Market and competitive analysis',
      'Technical feasibility assessment',
      'Success metrics and KPI definition'
    ],
    icon: Search
  },
  {
    id: 2,
    number: '02',
    title: 'Design & Planning',
    description: 'Transform insights into actionable plans with detailed architecture design, user experience mapping, and comprehensive technical roadmaps.',
    activities: [
      'System architecture and technical design',
      'User experience and interface design',
      'Project roadmap and milestone planning',
      'Risk assessment and mitigation strategies'
    ],
    icon: Palette
  },
  {
    id: 3,
    number: '03',
    title: 'Development & Iteration',
    description: 'Build your solution using agile methodologies, with regular sprints, continuous integration, and frequent client reviews for alignment.',
    activities: [
      'Agile development in 2-week sprints',
      'Continuous integration and testing',
      'Regular progress demos and feedback sessions',
      'Iterative refinement based on insights'
    ],
    icon: Code
  },
  {
    id: 4,
    number: '04',
    title: 'Testing & Refinement',
    description: 'Ensure excellence through rigorous quality assurance, performance optimization, and comprehensive security audits before launch.',
    activities: [
      'Comprehensive QA and bug resolution',
      'Performance optimization and load testing',
      'Security audits and vulnerability assessment',
      'Cross-browser and device compatibility testing'
    ],
    icon: TestTube
  },
  {
    id: 5,
    number: '05',
    title: 'Launch & Support',
    description: 'Deploy with confidence using proven strategies, provide thorough documentation and training, and offer ongoing optimization support.',
    activities: [
      'Deployment strategy and execution',
      'User training and documentation',
      'Post-launch monitoring and support',
      'Continuous optimization and improvements'
    ],
    icon: Rocket
  }
];

export const values = [
  {
    id: 'transparency',
    title: 'Transparency',
    description: 'Clear communication, honest timelines, and regular progress updates throughout our partnership. You\'re never left wondering about the status of your project.',
    icon: Eye
  },
  {
    id: 'excellence',
    title: 'Technical Excellence',
    description: 'We\'re committed to code quality, best practices, and staying ahead of technology trends. Our solutions are built to last and scale with your business.',
    icon: Award
  },
  {
    id: 'collaboration',
    title: 'True Partnership',
    description: 'We work alongside your team as trusted partners, not just vendors. Your input shapes the solution, and your success drives our decisions.',
    icon: Users
  },
  {
    id: 'innovation',
    title: 'Innovation Focus',
    description: 'We leverage cutting-edge technologies and creative problem-solving to deliver solutions that give you a competitive advantage in your market.',
    icon: TrendingUp
  }
];
